export default "/images/vendor/flag-icon-css/flags/4x3/tt.svg?b9a6939e2ab09927d19088bb11957702";